import { SiteContentProvider } from "@/shared/content/SiteContentProvider"
import { Header } from "@/shared/layout/Header"
import { Footer } from "@/shared/layout/Footer"
import { HeroSection } from "@/features/hero/HeroSection"
import { TrustSection } from "@/features/trust/TrustSection"
import { HowItWorksSection } from "@/features/how-it-works/HowItWorksSection"
import { PlansSection } from "@/features/plans/PlansSection"
import { BenefitsSection } from "@/features/benefits/BenefitsSection"
import { NetworkSection } from "@/features/network/NetworkSection"
import { AccreditationSection } from "@/features/accreditation/AccreditationSection"
import { AboutSection } from "@/features/about/AboutSection"
import { ClientAreaSection } from "@/features/client-area/ClientAreaSection"
import { FaqSection } from "@/features/faq/FaqSection"
import { CtaFinalSection } from "@/features/cta-final/CtaFinalSection"

/**
 * Pagina unica: a ordem das secoes abaixo e a ordem da narrativa comercial.
 *
 * Cada secao e uma feature autonoma em `src/features/` — le o proprio dado do
 * service que lhe interessa e nao conhece as vizinhas. Acrescentar, remover ou
 * reordenar secao e uma linha aqui.
 */
export default function App() {
  return (
    <SiteContentProvider>
      <div className="min-h-screen flex flex-col bg-off-white">
        <Header />

        {/* pt: altura do header fixo. pb no mobile: altura da barra de CTA. */}
        <main className="flex-1 pt-[72px] pb-16 lg:pb-0">
          <HeroSection />
          <TrustSection />
          <HowItWorksSection />
          <PlansSection />
          <BenefitsSection />
          <NetworkSection />
          <AccreditationSection />
          <AboutSection />
          <ClientAreaSection />
          <FaqSection />
          <CtaFinalSection />
        </main>

        <Footer />
      </div>
    </SiteContentProvider>
  )
}
